<template>
  <div>
    <resource-download-file v-bind:field="fields.resourcePdfFile" />
    <resource-download-file v-bind:field="fields.resourceWordFile" />
    <resource-download-file v-bind:field="fields.resourceExcelFile" />
  </div>
</template>

<script>
import ResourceDownloadFile from './CIS-ResourceDownloadFile.vue';
export default {
  name: 'CIS-ResourceDownload',
  props: {
    fields: {
      type: Object
    }
  },
  components: {
    ResourceDownloadFile
  }
};
</script>
